import React from "react";

export type ModalSize = "small" | "medium" | "large" | "extra-large";

export interface ModalSizeDimensions {
  width: string;
  maxWidth: number;
  height: string;
  maxHeight: string;
}

export const MODAL_SIZE_MAP: Record<ModalSize, ModalSizeDimensions> = {
  "small":       { width: "600px", maxWidth: 400,  height: "400px", maxHeight: "400px" },
  "medium":      { width: "800px", maxWidth: 800,  height: "600px", maxHeight: "600px" },
  "large":       { width: "1000px", maxWidth: 1200,  height: "800px", maxHeight: "800px" },
  "extra-large": { width: "1400px", maxWidth: 1400, height: "800px", maxHeight: "800px" },
};

export interface ModalBaseComponentProps {
  BodyModal?: any;
  HeaderModal?: any;
  FooterModal?: any;
  size?: ModalSize;
}

export type ModalProps = {
  visible?: boolean;
  data?: any;
  displayName?: DisplayNameModal;
  modalsAreOpen?: {
    displayName: DisplayNameModal;
    data?: any;
  }[];
  showHeader?: boolean;
  showFooter?: boolean;
  showBtnClose?: boolean;
  showBtnSave?: boolean;
  btnCloseModalClicked?: boolean | string | null;
  btnSaveModalClicked?: boolean | string | null;
  loadingBtnClosed?: boolean;
  loadingBtnSave?: boolean;
  txtBtnSave?: boolean | string | null;
  txtBtnBack?: boolean | string | null;
};

export type DisplayNameModal =
  | "editScreenshot"
  | "chooseBookmark"
  | "EventStationModal"
  | "RoomCameraModal"
  | "RoomCameraColorModal"
  | "ThemeModal"
  | "uploadConfirmationModal"
  | "CompetenceModal"
  | "CompetenceExtraModal"
  | "ThemeExtraModal"
  | "AppraisersList"
  | "AppraisersModal"
  | "CourseModal"
  | "CourseDetailsModal"
  | null;
